import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MaterialAppBar from '@material-ui/core/AppBar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { withFetch } from '~/hocs/fetch';
import { actionLogout } from '@/modules/application/actions/auth';
import '../styles/AppBar.scss';

let abortController;

const AppBar = (props) => {
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleClickExit = () => {
        abortController = new AbortController();
        setFetching(true);
        props.fetch.post('/api/auth/logout/', {}, abortController)
            .then(({ok,}) => {
                if (ok) {
                    props.logout();
                }
            })
            .catch((error) => {
                if (error !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };
    //noinspection JSValidateTypes
    return (
        <MaterialAppBar id="appbar" position="fixed">
            <Toolbar>
                <Typography className="logo">Tracker</Typography>
                <div className="right">
                    <Typography component={Link} to="/profile/">{props.user.username}</Typography>
                    <IconButton onClick={handleClickExit} disabled={fetching}>
                        <ExitToAppIcon/>
                    </IconButton>
                </div>
            </Toolbar>
        </MaterialAppBar>
    );
};

let Component = AppBar;
Component = withFetch(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    (dispatch) => ({
        logout: bindActionCreators(actionLogout, dispatch),
    })
)(Component);
